import * as Types from '../../../__generated__/types.js'

import { DocumentNode } from 'graphql'
import * as Apollo from '@apollo/client'
const defaultOptions = {} as const
export type GetCitiesQueryVariables = Types.Exact<{ [key: string]: never }>

export type GetCitiesQuery = {
    __typename: 'Query'
    cities: Array<{
        __typename: 'City'
        id: number
        name: string
        latitude: number
        longitude: number
        isDefault: boolean
        active: boolean
        countryId?: number | null | undefined
    }>
}

export const GetCitiesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'GetCities' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cities' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' }
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' }
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'latitude' }
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'longitude' }
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'isDefault' }
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'active' }
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'countryId' }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
} as unknown as DocumentNode

/**
 * __useGetCitiesQuery__
 *
 * To run a query within a React component, call `useGetCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCitiesQuery(
    baseOptions?: Apollo.QueryHookOptions<
        GetCitiesQuery,
        GetCitiesQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useQuery<GetCitiesQuery, GetCitiesQueryVariables>(
        GetCitiesDocument,
        options
    )
}
export function useGetCitiesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        GetCitiesQuery,
        GetCitiesQueryVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions }
    return Apollo.useLazyQuery<GetCitiesQuery, GetCitiesQueryVariables>(
        GetCitiesDocument,
        options
    )
}
export type GetCitiesQueryHookResult = ReturnType<typeof useGetCitiesQuery>
export type GetCitiesLazyQueryHookResult = ReturnType<
    typeof useGetCitiesLazyQuery
>
export type GetCitiesQueryResult = Apollo.QueryResult<
    GetCitiesQuery,
    GetCitiesQueryVariables
>
